import { SvgIcon, SvgIconProps } from "@mui/material"

const CopyOne = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M5.75 2a.75.75 0 0 1 .75-.75H15a.75.75 0 0 1 .75.75v5.25h4.75a.75.75 0 0 1 .75.75v11a.75.75 0 0 1-.75.75h-14a.75.75 0 0 1-.75-.75V2Zm1.5.75v15.5h12.5v-9.5H15a.75.75 0 0 1-.75-.75V2.75h-7Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M14.493 1.447a.75.75 0 0 1 1.06.046l5.5 6a.75.75 0 0 1-1.106 1.014l-5.5-6a.75.75 0 0 1 .046-1.06ZM3.5 9.25a.75.75 0 0 1 .75.75v11.25H14a.75.75 0 0 1 0 1.5H3.5a.75.75 0 0 1-.75-.75V10a.75.75 0 0 1 .75-.75Zm5.25.75a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Zm0 4a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Z" fill="currentColor" />
    </SvgIcon>
  )
}

export default CopyOne

